<div class="accordion-item" [ngClass]="{'opened':animationState === 'in'}">
  <div class="accordion-item__header" (click)="toggle()">
    <div class="accordion-item__icon" [inlineSVG]="icon" [resolveSVGUrl]="false"></div>
    <h3 class="accordion-item__title f-24-bold lh-relaxed">{{ title }}</h3>
  </div>
  <div class="accordion-item__content" [@slideInOut]="animationState">
    <p>{{text}}</p>
  </div>
</div>
